/**
 * Volume self-check (Oct 21 2026): shown in place of the volume slider when the Connector
 * found that no volume route changes this player's level. Merged into every catalog by
 * translations.js.
 */
const volumeControlI18n = {
  en: { volume_set_on_player: 'Volume for this player is set on the player itself' },
  es: { volume_set_on_player: 'El volumen de este reproductor se ajusta en el propio reproductor' },
  fr: { volume_set_on_player: 'Le volume de ce lecteur se règle sur le lecteur lui-même' },
  de: { volume_set_on_player: 'Die Lautstärke dieses Players wird am Player selbst eingestellt' },
  it: { volume_set_on_player: 'Il volume di questo lettore si regola direttamente sul lettore' },
  pt: { volume_set_on_player: 'O volume deste player é ajustado no próprio player' },
  ja: { volume_set_on_player: 'このプレーヤーの音量はプレーヤー本体で調整します' },
  ko: { volume_set_on_player: '이 플레이어의 볼륨은 플레이어 본체에서 조절합니다' },
  zh: { volume_set_on_player: '此播放器的音量需在播放器本身上调节' },
  nl: { volume_set_on_player: 'Het volume van deze speler stel je in op de speler zelf' },
  sv: { volume_set_on_player: 'Volymen för den här spelaren ställs in på själva spelaren' },
};

export default volumeControlI18n;
